<span class="material-symbols-outlined dialog__icon">emoji_food_beverage</span>
<h2 mat-dialog-title>ENJOY YOUR BREAK</h2>
<mat-dialog-content>
    @if ((timeSinceStatusChange | async) === 1){
    <p>You have been on break for {{this.timeSinceStatusChange | async}} minute</p>
    } @else {
    <p>You have been on break for {{this.timeSinceStatusChange | async}} minutes</p>
    }
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row w-100 mx-0">
        <div class="col-12">
  <button mat-flat-button class="w-100" color="primary" [mat-dialog-close]="true" cdkFocusInitial>END BREAK</button>

        </div>
    </div>
</mat-dialog-actions>